import { REGEX_TITLE_COUNTER } from './constants';
import { canUseDom } from './canUseDom';

export const getTitle = (newTitle: string): string => {
  const match = canUseDom && window?.document?.title?.match(REGEX_TITLE_COUNTER);

  return match ? `${match?.[0]} ${newTitle}` : newTitle;
};
